module.exports = __webpack_public_path__ + "img/1536011677.9874e7b1.jpg";